import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export function useE55Finalize() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fileId: number) => {
      const response = await axios.get(`/data-set/e55/finalize`, {
        params: {
          dataSet: fileId
        }
      });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate relevant queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['e55Samples'] });
      queryClient.invalidateQueries({ queryKey: ['e55FileDetails'] });
    }
  });
} 